<script setup lang="ts">
import { useI18n } from '@/composables/useI18n'
import BrandMark from '@/components/BrandMark.vue'

const { t } = useI18n()
const year = new Date().getFullYear()
</script>

<template>
  <footer class="footer">
    <div class="footer-inner">
      <BrandMark to="/" />
      <div class="footer-links">
        <router-link to="/how-it-works">{{ t('nav.howItWorks') }}</router-link>
        <router-link to="/pricing">{{ t('nav.pricing') }}</router-link>
        <router-link to="/legal">{{ t('nav.legal') }}</router-link>
      </div>
      <div class="footer-copy">© {{ year }} Bimdrop. {{ t('landing.footerRights') }}</div>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  border-top: 1px solid var(--border);
  padding: 2rem 1.25rem;
}

.footer-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.footer-links {
  display: flex;
  gap: 1.5rem;
}

.footer-links a {
  color: var(--text-subtle);
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: var(--text);
}

.footer-copy {
  font-size: 0.8rem;
  color: var(--text-faint);
}

@media (max-width: 768px) {
  .footer-inner {
    flex-direction: column;
    text-align: center;
  }
}
</style>
